const headerChange = () => {
  const header = document.getElementById('js-header')
  const headerHeight = header.offsetHeight
  let prevScrollPos = window.pageYOffset || document.documentElement.scrollTop

  window.addEventListener('scroll', function () {
    const currentScrollPos =
      window.pageYOffset || document.documentElement.scrollTop

    if (currentScrollPos > prevScrollPos && currentScrollPos > headerHeight) {
      header.classList.add('header-hide')
    } else {
      header.classList.remove('header-hide')
    }

    prevScrollPos = currentScrollPos
  })
}

export default headerChange
